/**
 * Santander BFF component for add-family-member MFE
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreateContractResponseDTO {
  policyId?: string;
  paymentId: string;
}
